import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PaymentModel } from 'src/app/core/models/payment.model';
import { PaymentHistoryRequest } from 'src/app/core/models/request/payment-history.request';
import { SessionCacheModel } from 'src/app/core/models/session-cache.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { SessionCacheService } from 'src/app/core/services/session-cache.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { DetailPayComponent } from 'src/app/pages/detail-pay/detail-pay.component';
import { DetailPaymentService } from 'src/app/pages/detail-pay/services/detail.payment.service';
import { ActionOptions } from 'src/app/shared/interfaces/actionOption';
import { AppIcon } from 'src/app/shared/interfaces/app-icon';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';
import { runtimeEnv } from 'src/environments/env-loader';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-minimized-list',
  templateUrl: './minimized-list.component.html',
  styleUrls: ['./minimized-list.component.scss']
})
export class MinimizedListComponent implements OnInit {
  readonly MINIMIZED_LIST = 'minimized';
  readonly TO_MILISECONDS = runtimeEnv.THROTTLEDREFRESHBALANCE * 1000;

  downloadLoading = false;

  constructor(
    public dialog: MatDialog,
    private paymentsService: PaymentsService,
    private storage: StorageService,
    private translateService: TranslateService,
    private paymentIconsService: PaymentIconsService,
    private data: DetailPaymentService,
    private router: Router,
    private identity: IdentityService,
    private sessionCache: SessionCacheService,
    private nativeBridgeService: NativeBridgeService
  ) {}

  search = new UntypedFormControl('');
  loading: boolean;
  totalSize: number = 0;
  dateFrom: Date;
  filter: string;
  movimientosList: any;
  filterMovs: PaymentModel[];
  periodoActual: string = '';
  estadoActual: [];
  noMovements: boolean = false;
  pageActual: any;

  estadoDelPago: Array<IOptionsNgSelect>;

  appEnvironment: string;

  maskCuit(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(2, 10);
    let end = cuit.substring(10, 11);
    return `${first}-${dni}-${end}`;
  }

  getIcon(icon: string, billetera?): AppIcon {
    return this.paymentIconsService.getIcon(icon, billetera);
  }

  setClassEstado(estado: string) {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Acreditado') return 'confirmado';
    else if (estado == 'Aprobado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  filtroGeneral(value?: any) {
    this.filterMovs = this.movimientosList;
    this.handleSearch(this.search.value);
    this.filterMovs.length == 0 ? (this.noMovements = false) : (this.noMovements = true);
  }

  handleSearch(value: string) {
    this.filterMovs = !value
      ? this.filterMovs
      : this.filterMovs.filter((mov) => mov.titulo.toUpperCase().includes(value.toUpperCase()));
  }

  commerceUser: boolean = true;
  userResponsible: boolean = true;

  async ngOnInit() {
    this.estadoDelPago = [
      { value: 1, display: this.translate('constants.payment_status.d'), type: 'D' },
      { value: 2, display: this.translate('constants.payment_status.a'), type: 'A' },
      { value: 3, display: this.translate('constants.payment_status.p'), type: 'P' },
      { value: 4, display: this.translate('constants.payment_status.c'), type: 'C' },
      { value: 5, display: this.translate('constants.payment_status.r'), type: 'R' },
      { value: 6, display: this.translate('constants.payment_status.n'), type: 'N' },
      { value: 7, display: this.translate('constants.payment_status.u'), type: 'U' },
      { value: 8, display: this.translate('constants.payment_status.e'), type: 'E' }
    ] as IOptionsNgSelect[];
    this.appEnvironment = this.nativeBridgeService.getEnvironment();
    this.loading = true;
    this.commerceUser = this.identity.isCommerce();
    this.userResponsible = this.identity.isRolResponsible();
    this.sessionCache.expiredData(this.MINIMIZED_LIST);
    await this.getDataGrid();
    this.loading = false;
  }

  async getDataGrid() {
    let session = this.sessionCache.getData(this.MINIMIZED_LIST);
    !session ? this.createRequestAndSaveInCache() : this.keepCache();
  }

  async createRequestAndSaveInCache(): Promise<void> {
    const request = this.createRequest();
    const movimientos = await this.paymentsService.getPaymentHistory(request);
    this.movimientosList = movimientos.list;
    this.filterMovs = this.movimientosList;
    let values = new SessionCacheModel();
    values.data = this.movimientosList;
    values.iat = +new Date() + this.TO_MILISECONDS;
    this.sessionCache.saveDataWithExpiration(this.MINIMIZED_LIST, values);
  }

  keepCache(): void {
    this.movimientosList = JSON.parse(this.sessionCache.getData(this.MINIMIZED_LIST)).data;
    this.filterMovs = this.movimientosList;
  }

  private createRequest(allSize?: boolean): PaymentHistoryRequest {
    let request = new PaymentHistoryRequest();
    if (allSize != undefined && allSize) {
      request.elements = this.totalSize;
      request.page = 0;
    } else {
      request.elements = 0;
      request.page = 0;
    }
    request.estadosPago = new Array<string>();

    if (this.estadoActual && this.estadoActual.length > 0) {
      this.estadoActual.forEach((element) => {
        request.estadosPago.push(this.estadoDelPago[+element - 1].type);
      });
    } else {
      this.estadoDelPago.forEach((element) => {
        request.estadosPago.push(element.type);
      });
    }
    return request;
  }

  maskPrice(price: string) {
    if (price.startsWith('-')) {
      let importe = price.slice(1);
      return `-$${importe}`;
    } else {
      return `$${price}`;
    }
  }

  clickInAction(element: any, action: ActionOptions) {
    switch (action.name) {
      case 'pageview': {
        this.data.storage = element;
        const diagRef = this.dialog.open(DetailPayComponent, { minWidth: '350px' });
        diagRef.afterClosed().subscribe((x) => (x ? (x.refresh ? this.getDataGrid() : null) : null));
        break;
      }

      case 'save_alt': {
        this.paymentsService
          .downloadTicket(element.id)
          .then(() => {
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
        break;
      }
    }
  }

  goToMovements() {
    this.router.navigate(['/user/movements']);
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }
}
